import axios from "axios";

// ##############################
// Data extraction from S3
// ##############################
export async function getFromS3URL(url) {
  const options = {
    url,
  };
  try {
    const { data, status } = await axios(options);

    if (status === 200) {
      // console.log("getFromURL", data);
      return data;
    } else {
      throw new Error(status);
    }
  } catch (err) {
    throw err;
  }
}
